import { combineReducers } from 'redux'
import user from './User'
import data from './Data'
import config from './Config'
import users from './Users'
import laundryTimes from './LaundryTimes'
import laundries from './Laundries'
import laundryRules from './LaundryRules'
import informationItems from './InformationItems'
import laundryBookings from './LaundryBookings'
import bookingSystems from './BookingSystems'
import bookingSystemTimes from './BookingSystemTimes'
import newsFeed from './NewsFeed'

export default combineReducers({
  user,
  data,
  config,
  users,
  laundryTimes,
  laundries,
  laundryRules,
  informationItems,
  laundryBookings,
  bookingSystems,
  bookingSystemTimes,
  newsFeed
})



// WEBPACK FOOTER //
// ./src/components/reducers/index.js